import { ReactElement } from 'react';

interface TanstackFieldWrapperProps<TValue> {
  field: any;
  children: (props: {
    value: TValue;
    onChange: (value: TValue) => void;
    onBlur: () => void;
    invalid: boolean;
    invalidText: string | undefined;
  }) => ReactElement;
}

export function TanstackFieldWrapper<TValue>({
  field,
  children,
}: TanstackFieldWrapperProps<TValue>) {
  const errors = field.state.meta.errors || [];
  const firstError = errors[0];
  const errorText =
    typeof firstError === 'string'
      ? firstError
      : firstError
        ? String(firstError)
        : undefined;

  return children({
    value: field.state.value as TValue,
    onChange: (value: TValue) => field.handleChange(value),
    onBlur: () => field.handleBlur(),
    invalid: !!errorText,
    invalidText: errorText,
  });
}
